import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import { serviceDivision, varHighStatus, varSpace, varSquareMeter } from "../../Variable";
import arrowIcon from "../../assets/icons/arrow_forward_ios.svg";
import searchIcon from "../../assets/icons/search.svg";
import { get_brand_select, get_my_complete_construction_list, get_product_select, insert_portfolio } from "../../Axios";
import { useDispatch } from "react-redux";
import { reduxOffSpinner, reduxOnSpinner } from "../../redux/CommonSlice";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { filter_bad_word, get_day_timestamp } from "../../Validation";
import { search_regExp, update_nav } from "../../Util";
import theme from "../../style/theme";

const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;

const PostPortfolio: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const customerData = useSelector((state:RootState) => state.customerData);
    const [activeDropdown, setActiveDropdown] = useState<number>(0);
    const [activeList, setActiveList] = useState<any[]>([]);

    const [division, setDivision] = useState<string>("서비스 선택");
    const [brand, setBrand ] = useState<string>("브랜드 선택");
    const [product, setProduct] = useState<any>("제품 선택");
    const [highStatus, setHighStatus] = useState<string>("천장높이 선택");
    const [squareMeter, setSquareMeter] = useState<string>("전체 평수 선택");
    const [space, setSpace] = useState<string>("설치 장소 선택");

    const [reservationID, setReservationID] = useState<number>(0); // 이전 시공 선택시 예약 번호 => 0 일시 직접입력
    const [divisionID, setDivisionID] = useState<number>(0);
    const [brandID, setBrandID] = useState<number>(0);
    const [colorID, setColorID] = useState<number>(0);
    const [highStatusNumber, setHighstatusNumber] = useState<number>(0);
    const [reservationSquareMeter, setReservationSquareMeter] = useState<number>(-1);
    const [reservationSpace, setReservationSpace] = useState<number>(0);
    const [review, setReview] = useState<string>("");
    const [reviewLength, setReviewLength] = useState<number>(0);
    const [productLenderingList, setProductLenderingList] = useState<any[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [completeConstructionList, setCompleteConstructionList] = useState<any[]>([]);
    const [constructionSearchText, setConstructionSearchText] = useState<string>("");
    const [constructionLenderingList, setConstructionLenderingList] = useState<any[]>([]);

    const [portfolioPhotoList, setPortfolioPhotoList] = useState<File[]>([]);
    const [portfolioPreviewList, setPortfolioPreviewList] = useState<string[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [prevConstruct, setPrevConstruct] = useState<string | null>("직접 입력");

    const handleActiveDropdown = (num: number) => {
        if(activeDropdown === num) {
            return setActiveDropdown(0);
        }
        setActiveDropdown(num);
    };

    // 셀렉트 박스 => 1: 서비스 유형, 2: 브랜드, 3: 제품명, 4: 이전 시공목록, 5: 천장 높이 6: 전체 평수, 7: 설치 장소
    useEffect(() => {
        switch (activeDropdown) {
            case 1 : setActiveList(serviceDivision); break;
            case 2 : handleSelectBrandList(); break;
            case 3 : if(brandID === 0) {
                    setActiveDropdown(0);
                    return alert('브랜드를 선택해 주세요');
                } else {
                    handleSelectProductList(brandID.toString());
                } break;
            case 4 : handleSelectCompleteConstructionList(); break;
            case 5 : setActiveList(varHighStatus); break;
            case 6 : setActiveList(varSquareMeter); break;
            case 7 : setActiveList(varSpace); break;
            default : setActiveList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDropdown, brandID]);

    // 현재 활성화된 셀렉트 박스에 따라서 state 변경
    const handleSelectProductList = (brand_ID: string) => {
        get_product_select(brand_ID).then(result => {
            setActiveList(result);
        });
    };

    const handleSelectBrandList = () => {
        get_brand_select().then(result => {
            setActiveList(result);
        });
    };

    const handleSelectCompleteConstructionList = () => {
        get_my_complete_construction_list(customerData.customer_ID).then(result => {
            setActiveList(result);
            setCompleteConstructionList(result);
        });
    };

    useEffect(() => {
        let list = [];
        if(!searchText) {
            list = activeList;
        } else {
            list = activeList.filter((tmp) => {
                let search = searchText.toLowerCase().trim().split(' ').join('');
                return (
                    search_regExp(tmp.product_kor_name).includes(search) ||
                    search_regExp(tmp.color_name).includes(search) ||
                    search_regExp(tmp.product_eng_name).includes(search) ||
                    search_regExp(tmp.product_name).includes(search)
                )
            });
        };
        setProductLenderingList(list);
    }, [activeList, searchText]);

    useEffect(() => {
        let list = [];
        if(!constructionSearchText) {
            list = activeList;
        } else {
            list = activeList.filter((tmp) => {
                let arr = get_day_timestamp(tmp.construction_reservation_reservationTime).year_month_day;
                let reservation_date_str = arr.split('-').join('');
                let search = constructionSearchText.toLowerCase().trim().split(' ').join('');
                return (
                    search_regExp(tmp.product_kor_name).includes(search) ||
                    search_regExp(tmp.product_eng_name).includes(search) ||
                    search_regExp(tmp.brand_kor_name).includes(search) ||
                    search_regExp(tmp.brand_eng_name).includes(search) ||
                    search_regExp(tmp.select_name).includes(search) ||
                    search_regExp(tmp.construction_reservation_name).includes(search) ||
                    search_regExp(tmp.construction_reservation_reservationTime).includes(search) ||
                    reservation_date_str.includes(constructionSearchText)
                );
            });
        };
        setConstructionLenderingList(list);
    }, [activeList, constructionSearchText]);

    // 사진 추가시 배열에 추가
    const insertFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];
        if(file) {
            let list = [...portfolioPhotoList];
            list.push(file);
            setPortfolioPhotoList(list);
        }
    };

    // 사진 삭제시 해당 index 배열에서 삭제
    const removeFile = (idx: number) => {
        let list = [...portfolioPhotoList];
        list.splice(idx, 1);
        setPortfolioPhotoList(list);
    };

    // 배열의 값이 변할 때 마다 새로 배열 짜서 순서대로 화면에 표시
    useEffect(() => {
        let list = [];
        for (let i = 0; i < portfolioPhotoList.length; i++) {
            const objectUrl = URL.createObjectURL(portfolioPhotoList[i]);
            list.push(objectUrl);
        }
        setPortfolioPreviewList(list);
    }, [portfolioPhotoList]);

    useEffect(() => {
        if(reservationID === 0) {
            setPrevConstruct("직접 입력");
        }
    }, [reservationID]);

    return (
        <S.SectionContainer onClick={(e:React.MouseEvent<HTMLDivElement>) => {
            if(activeDropdown === 0) return;
            const target = e.target as HTMLElement;
            if(target.classList.contains('product-search-box') || target.classList.contains('product-search-input')) return;
            if(target.classList.contains('prev-construct-search-box') || target.classList.contains('prev-construct-search-input')) return;
            if(target.classList.contains('prev-construct-search-icon') || target.classList.contains('product-search-icon')) return;
            if(e.target !== e.currentTarget) {
                setActiveDropdown(0);
            }
        }}>
            <S.SectionWidth $width={1080}>
                <S.SectionTitleBox>
                    <h1>포트폴리오 등록</h1>
                    <h3>시공 포트폴리오를 등록하시면 AP포인트를 발급해드립니다.</h3>
                </S.SectionTitleBox>

                <div className="flex justify-center">
                    <S.PostPortfolioContainer>

                        {/* 이전 시공 목록중에서 선택 */}
                        <div className="select-box">
                            <S.DropdowMenuButton className="z-[198]" $activeButton={activeDropdown === 4 ? true : false} onClick={() => handleActiveDropdown(4)}>
                                <span>{prevConstruct}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 4 &&
                                <>
                                    <div className="prev-construct-search-box">
                                        <input
                                            className="prev-construct-search-input"
                                            type="text"
                                            value={constructionSearchText}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setConstructionSearchText(e.target.value);
                                            }}
                                        />
                                        <img className="prev-construct-search-icon" src={searchIcon} alt="" />
                                    </div>
                                    <S.DropdownHideMenu style={{paddingTop: "55px"}} className="top-[50px] min-h-[180px]" onClick={(e) => {
                                        if(!(e.target instanceof HTMLElement)) return;
                                        if(!e.target.classList.contains('click-target')) return;
                                        const target = e.target.dataset.value;
                                        const text = e.target.textContent;
                                        let object = completeConstructionList.filter(tmp => Number(target) === tmp.construction_reservation_ID)[0];
                                        setPrevConstruct(text);
                                        setReservationID(object.construction_reservation_ID);
                                        setDivision(object.construction_reservation_division_name);
                                        setDivisionID(object.construction_reservation_division);
                                        setBrand(object.brand_kor_name);
                                        setBrandID(object.construction_reservation_brand_ID);
                                        setProduct(text);
                                        setColorID(object.color_ID_use_construction_reservation);
                                        setHighStatus(object.construction_reservation_high_status_name);
                                        setHighstatusNumber(object.construction_reservation_high_status);
                                        setSquareMeter(object.construction_reservation_square_meter_name);
                                        setReservationSquareMeter(object.construction_reservation_square_meter);
                                        setSpace(object.construction_reservation_space_name);
                                        setReservationSpace(object.construction_reservation_space);
                                    }}>
                                        {/* <p data-value={"0"}>직접입력</p> */}
                                    {constructionLenderingList.map((tmp, idx) => 
                                        <p className="click-target" key={idx} data-value={tmp.construction_reservation_ID}>
                                            {tmp.select_name} ({get_day_timestamp(tmp.construction_reservation_reservationTime).year_month_day}) {tmp.construction_reservation_name} 
                                        </p>
                                    )}
                                    </S.DropdownHideMenu>
                                </>
                            }
                        </div>

                        <div className="select-box">
                            <S.DropdowMenuButton className="z-[197] top-[50px]" $activeButton={activeDropdown === 1 ? true : false} onClick={() => handleActiveDropdown(1)}>
                                <span className={`${division === "서비스 선택" && "text-gray-400"}`}>{division}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 1 &&
                                <S.DropdownHideMenu className="top-[100px]" onClick={(e) => {
                                    if(!(e.target instanceof HTMLElement)) return;
                                    if(!e.target.classList.contains('click-target')) return;
                                    if(reservationID !== 0) {
                                        setReservationID(0);
                                    }
                                    const target = e.target.dataset.value;
                                    setDivisionID(Number(target));
                                    setDivision(serviceDivision.filter((tmp) => tmp.value === target)[0].label);
                                }}>
                                    {activeList.map((tmp, idx) => 
                                        <p className="click-target" key={idx} data-value={tmp.value}>{tmp.label}</p>
                                    )}
                                </S.DropdownHideMenu>
                            }
                        </div>

                        <div className="select-box">
                            <S.DropdowMenuButton className="z-[196] top-[100px]" $activeButton={activeDropdown === 2 ? true : false} onClick={() => handleActiveDropdown(2)}>
                                <span className={`${brand === "브랜드 선택" && "text-gray-400"}`}>{brand}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 2 &&
                                <S.DropdownHideMenu className="top-[150px]" onClick={(e) => {
                                    if(!(e.target instanceof HTMLElement)) return;
                                    if(!e.target.classList.contains('click-target')) return;
                                    if(reservationID !== 0) {
                                        setReservationID(0);
                                    }
                                    const target = e.target.dataset.value;
                                    setBrandID(Number(target));
                                    setProduct("제품 선택");
                                    setBrand(activeList.filter((tmp) => tmp.brand_ID === Number(target))[0].brand_kor_name);
                                }}>
                                    {activeList.map((tmp, idx) => 
                                        <p className="click-target" key={idx} data-value={tmp.brand_ID}>{tmp.brand_kor_name}</p>
                                    )}
                                </S.DropdownHideMenu>
                            }
                        </div>

                        <div className="select-box">
                            <S.DropdowMenuButton className="z-[195] top-[150px]" $activeButton={activeDropdown === 3 ? true : false} onClick={() => handleActiveDropdown(3)}>
                                <span className={`${product === "제품 선택" && "text-gray-400"}`}>{product}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 3 &&
                                <>
                                    <div className="product-search-box">
                                        <input
                                            className="product-search-input"
                                            type="text"
                                            value={searchText}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    setSearchText(e.target.value);
                                            }}
                                        />
                                        <img className="product-search-icon" src={searchIcon} alt="" />
                                    </div>
                                    <S.DropdownHideMenu style={{paddingTop: "55px"}} className="top-[200px] min-h-[180px]" onClick={(e) => {
                                        if(!(e.target instanceof HTMLElement)) return;
                                        if(!e.target.classList.contains('click-target')) return;
                                        if(reservationID !== 0) {
                                            setReservationID(0);
                                        }
                                        const target = e.target.textContent;
                                        const color_ID = e.target.dataset.value;
                                        setSearchText("");
                                        setProduct(target);
                                        setColorID(Number(color_ID));
                                    }}>
                                        {productLenderingList.map((tmp, idx) => 
                                            <p className="click-target" key={idx} data-value={`${tmp.color_ID}`}>
                                                {tmp.product_name} - {tmp.color_name}
                                            </p>
                                        )}
                                    </S.DropdownHideMenu>
                                </>
                            }
                        </div>

                        <div className="select-box">
                            <S.DropdowMenuButton className="z-[194] top-[200px]" $activeButton={activeDropdown === 5 ? true : false} onClick={() => handleActiveDropdown(5)}>
                                <span className={`${highStatus === "천장높이 선택" && "text-gray-400"}`}>{highStatus}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 5 &&
                                <S.DropdownHideMenu className="top-[250px]" onClick={(e) => {
                                    if(!(e.target instanceof HTMLElement)) return;
                                    if(!e.target.classList.contains('click-target')) return;
                                    if(reservationID !== 0) {
                                        setReservationID(0);
                                    }
                                    const target = e.target.dataset.value;
                                    setHighstatusNumber(Number(target));
                                    setHighStatus(varHighStatus.filter((tmp) => tmp.value === target)[0].label);
                                }}>
                                    {activeList.map((tmp, idx) =>
                                        <p className="click-target" key={idx} data-value={tmp.value}>{tmp.label}</p>
                                    )}
                                </S.DropdownHideMenu>
                            }
                        </div>
                        
                        {/* 전체 평수 & 설치장소 */}
                        <div className="select-box">
                            <S.DropdowMenuButton
                                $activeButton={activeDropdown === 6 ? true : false}
                                className="z-[194] top-[250px]"
                                onClick={() => handleActiveDropdown(6)}
                            >
                                <span className={`${squareMeter === "전체 평수 선택" && "text-gray-400"}`}>{squareMeter}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 6 && (
                                <S.DropdownHideMenu
                                    className="top-[300px]"
                                    onClick={(e) => {
                                        if (!(e.target instanceof HTMLElement)) return;
                                        if (!e.target.classList.contains('click-target')) return;
                                        if(reservationID !== 0) {
                                            setReservationID(0);
                                        }
                                        const target = e.target.dataset.value;
                                        setReservationSquareMeter(Number(target));
                                        setSquareMeter(varSquareMeter.filter(tmp => tmp.value === target)[0].label);
                                    }}
                                >
                                    {activeList.map((tmp, idx) =>
                                        <p className="click-target" key={idx} data-value={tmp.value}>{tmp.label}</p>
                                    )}
                                </S.DropdownHideMenu>
                            )}
                        </div>
                        <div className="select-box">
                            <S.DropdowMenuButton
                                $activeButton={activeDropdown === 7 ? true : false}
                                className="z-[194] top-[300px]"
                                onClick={() => handleActiveDropdown(7)}
                            >
                                <span className={`${space === "설치 장소 선택" && "text-gray-400"}`}>{space}</span>
                                <img src={arrowIcon} alt="" />
                            </S.DropdowMenuButton>
                            {activeDropdown === 7 && (
                                <S.DropdownHideMenu
                                    className="top-[350px]"
                                    onClick={e => {
                                        if (!(e.target instanceof HTMLElement)) return;
                                        if (!e.target.classList.contains('click-target')) return;
                                        if(reservationID !== 0) {
                                            setReservationID(0);
                                        }
                                        const target = e.target.dataset.value;
                                        setReservationSpace(Number(target));
                                        setSpace(varSpace.filter(tmp => tmp.value === target)[0].label);
                                    }}
                                >
                                    {activeList.map((tmp, idx) =>
                                        <p className="click-target" key={idx} data-value={tmp.value}>{tmp.label}</p>
                                    )}
                                </S.DropdownHideMenu>
                            )}
                        </div>

                        <S.CommunityReviewBox className="mt-[350px]">
                            <textarea 
                                onChange={(e) => {
                                    let str = e.target.value;
                                    setReview(str.replaceAll("<br>", "\r\n"));
                                    setReviewLength(str.length);
                                }}
                                rows={10} placeholder={`에이블랙의 하이엔드 시공 서비스를 경험한 후기를 들려주세요.\n후기를 남겨주시는 분들께 500AP포인트를 적립해드려요.`} maxLength={2500}
                                value={review}
                            ></textarea>
                            <div className="length-box">
                                <span>{reviewLength}</span>&nbsp;
                                <span>/ 2500</span>
                            </div>
                        </S.CommunityReviewBox>
                        <h1 className="font-medium text-mainBlack text-[14px] leading-[150%] mt-[15px]">
                            현장 사진 / 동영상 (최대 4장까지 가능)
                        </h1>

                        <S.PhotoBox $gridColumn={4} className="mt-2">
                            {portfolioPhotoList[0] ?
                                <div className="prev-item" onClick={() => removeFile(0)}>
                                    <img className="prev-img" src={portfolioPreviewList[0]} alt="" />
                                    <div className="prev-hover">삭제</div>
                                </div>
                                :
                                <div>
                                    <input type="file" id="ex_photo_1" name='portfolio_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                                    <label htmlFor="ex_photo_1">
                                        <div className="photo-item">+</div>
                                    </label>
                                </div>
                            }
                            {portfolioPhotoList[1] ? 
                                <div className="prev-item" onClick={() => removeFile(1)}>
                                    <img className="prev-img" src={portfolioPreviewList[1]} alt="" />
                                    <div className="prev-hover">삭제</div>
                                </div>
                                :
                                <div>
                                    <input type="file" id="ex_photo_2" name='portfolio_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                                    <label htmlFor="ex_photo_2">
                                        <div className="photo-item">+</div>
                                    </label>
                                </div>
                            }
                            {portfolioPhotoList[2] ?
                                <div className="prev-item" onClick={() => removeFile(2)}>
                                    <img className="prev-img" src={portfolioPreviewList[2]} alt="" />
                                    <div className="prev-hover">삭제</div>
                                </div>
                                :
                                <div>
                                    <input type="file" id="ex_photo_3" name='portfolio_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                                    <label htmlFor="ex_photo_3">
                                        <div className="photo-item">+</div>
                                    </label>
                                </div>
                            }
                            {portfolioPhotoList[3] ?
                                <div className="prev-item" onClick={() => removeFile(3)}>
                                    <img className="prev-img" src={portfolioPreviewList[3]} alt="" />
                                    <div className="prev-hover">삭제</div>
                                </div>
                                :
                                <div>
                                    <input type="file" id="ex_photo_4" name='portfolio_photo_list' accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={insertFile} />
                                    <label htmlFor="ex_photo_4">
                                        <div className="photo-item">+</div>
                                    </label>
                                </div>
                            }
                        </S.PhotoBox>
                        
                        <S.SectionContent>
                            <div className="section-flex-box w-[550px] mt-10">
                                <S.EmptyRoundedButton onClick={() => {
                                    let bad_word_list = filter_bad_word(review);
                                    if(bad_word_list.length > 0) return alert(`부적절한 단어가 감지되었습니다. [${bad_word_list}]`);
                                    if(!divisionID) return alert('서비스 유형을 선택해주세요.');
                                    if(!brandID) return alert('브랜드를 선택해주세요.');
                                    if(!colorID) return alert('제품을 선택해주세요.');
                                    if(reservationSquareMeter === -1) return alert ('전체 평수를 선택해주세요.');
                                    if(!reservationSpace) return alert('설치 장소를 선택해주세요.');
                                    if(!review.trim()) return alert('후기 내용을 작성해주세요.');
                                    if(!portfolioPhotoList.length) return alert('최소 하나이상의 시공 이미지가 필요합니다.');
                                    if(!window.confirm('포트폴리오를 등록하시겠습니까?')) return;
                                    dispatch(reduxOnSpinner("포트폴리오를 등록 중입니다."));
                                    insert_portfolio(
                                        customerData.customer_ID,
                                        brandID,
                                        colorID,
                                        divisionID,
                                        review,
                                        portfolioPhotoList,
                                        highStatusNumber,
                                        reservationID,
                                        reservationSquareMeter,
                                        reservationSpace,
                                    ).then(result => {
                                        if(result === 1) {
                                            update_nav();
                                            alert('포트폴리오가 등록되었습니다.');
                                            navigate('/community');
                                        } else {
                                            alert('알 수 없는 오류입니다.');
                                            navigate('/community');
                                        };
                                    });
                                    dispatch(reduxOffSpinner());
                                }} $width={280} $btnSelect={false} style={{backgroundColor : mainBlack, color : mainWhite}}>
                                    등록하기
                                </S.EmptyRoundedButton>
                            </div>
                        </S.SectionContent>

                        <U.BreakLine $height={60} />
                    </S.PostPortfolioContainer>
                </div>
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default PostPortfolio;